/* Eadflie Wishlist — heart button + header badge (event delegation) */
(function () {
  var KEY = 'eadflie_wl_v1';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function setList(arr) {
    localStorage.setItem(KEY, JSON.stringify(arr));
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: arr } }));
  }

  function updateHeaderBadge() {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (bubble) {
      var valEl = bubble.querySelector('[data-wishlist-count-value]');
      var count = getList().length;
      if (valEl) valEl.textContent = count;
      if (count === 0) bubble.setAttribute('hidden', '');
      else bubble.removeAttribute('hidden');
    });
  }

  function getCurrentProductHandle() {
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function syncButtonState(btn, handle) {
    var active = getList().indexOf(handle) !== -1;
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function syncAllButtons() {
    document.querySelectorAll('.figs-wishlist').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle') || getCurrentProductHandle();
      if (!handle) return;
      syncButtonState(btn, handle);
    });
  }

  /* CAPTURE-phase delegated click:
     Runs before any other click handler or default link navigation. */
  function onClickCapture(e) {
    var btn = e.target && e.target.closest && e.target.closest('.figs-wishlist');
    if (!btn) return;

    // Stop everything — including parent <a> navigation and card overlay links.
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var handle = btn.getAttribute('data-product-handle') || getCurrentProductHandle();
    if (!handle) return;

    var list = getList();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.unshift(handle);
      btn.classList.add('is-pop');
      setTimeout(function () { btn.classList.remove('is-pop'); }, 400);
    } else {
      list.splice(idx, 1);
    }
    setList(list);
    syncButtonState(btn, handle);
  }

  /* Register in capture phase on document + window for maximum precedence */
  document.addEventListener('click', onClickCapture, true);

  document.addEventListener('wishlist:change', function () {
    updateHeaderBadge();
    syncAllButtons();
  });

  function init() {
    updateHeaderBadge();
    syncAllButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-sync after Shopify section re-renders (theme editor, filter updates) */
  document.addEventListener('shopify:section:load', init);
})();
